import React, { useCallback, useState } from "react";
import { Button, Form, Input, Modal, Card, message, Spin, Space } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import axios from "axios";
import dayjs from "dayjs";
import {
  HEADERS_EXPORT_BEN,
  POST_UPDATE_FINAL_CASE_DATE,
} from "../../../API/apiUrls";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";

const { TextArea } = Input;

const UpdateFinalCaseDoc = ({ open, onCancel, dataDefault, onSuccess }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  // ✅ ปิด Modal และ Reset
  const handleClose = useCallback(() => {
    form.resetFields();
    setFileList([]);
    onCancel?.();
  }, [form, onCancel]);

  // ✅ ส่งข้อมูล
  const sendStatus = async (data) => {
    setLoading(true);
    try {
      const res = await axios.post(POST_UPDATE_FINAL_CASE_DATE, data, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        message.success("อัพเดทข้อมูลสำเร็จ");
        handleClose();
        onSuccess?.();
      } else {
        message.error("ไม่สามารถส่งข้อมูลได้");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error(
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล",
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ Submit Form
  const onFinish = (values) => {
    if (fileList.length < 1) {
      message.error("กรุณาเลือกไฟล์เพื่ออัปโหลด");
      return;
    }

    const postData = {
      lawsuitId: dataDefault?.lawsuitId,
      loanId: dataDefault?.loanId,
      finalCaseDate: values.finalCaseDate
        ? dayjs(values.finalCaseDate).format()
        : null,
      idJudge: dataDefault.idJudge,
      mark: values.memo || null,
      userId: userId,
    };

    console.log("postData:", postData);
    sendStatus(postData);
  };

  const onFinishFailed = () => {
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบ");
  };

  // ✅ Upload Props
  const uploadProps = {
    multiple: true,
    fileList,
    onRemove: (file) => {
      setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    },
    beforeUpload: (file) => {
      const isLt5M = file.size / 1024 / 1024 < 5.1;

      if (!isLt5M) {
        message.error(`❌ ไฟล์ "${file.name}" มีขนาดเกิน 5 MB`);
        return false;
      }

      setFileList((prev) => [...prev, file]);
      return false; // ป้องกันการอัปโหลดอัตโนมัติ
    },
  };
  console.log(dataDefault);

  // ✅ แสดงชื่อเจ้าของสัญญา
  const ownerName = dataDefault
    ? `${dataDefault.CONTNO || ""} / ${dataDefault.SNAM || ""}${
        dataDefault.NAME1 || ""
      } ${dataDefault.NAME2 || ""}`.trim()
    : "-";

  return (
    <Modal
      title="ลงข้อมูลคดีถึงที่สุด"
      open={open}
      onCancel={handleClose}
      width={850}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังบันทึก...">
        <Card>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 14 }}
            layout="horizontal"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item label="เลขสัญญา/เจ้าของสัญญา">
              <span style={{ fontWeight: 500 }}>{ownerName}</span>
            </Form.Item>

            <Form.Item label="หมายเลขคดีดำ" name="blackNumber">
              {dataDefault?.blackNumber}
            </Form.Item>

            <Form.Item label="หมายเลขคดีแดง" name="redNumber">
              {dataDefault?.redCaseNumber}
            </Form.Item>

            <Form.Item
              label="วันที่คดีสิ้นสุด"
              name="finalCaseDate"
              rules={[{ required: true, message: "กรุณาเลือกวันที่" }]}
            >
              <ThaiDatePicker style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item
              label="ไฟล์เอกสาร"
              name="imageUrlFile"
              rules={[{ required: true, message: "กรุณาเลือกไฟล์" }]}
            >
              <Dragger {...uploadProps}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ color: "#1890ff" }} />
                </p>
                <p className="ant-upload-text">
                  กรุณาคลิกหรือลากไฟล์มาวางที่นี่
                </p>
              </Dragger>
            </Form.Item>

            <Form.Item label="หมายเหตุ" name="memo">
              <TextArea rows={4} placeholder="ระบุหมายเหตุ (ถ้ามี)" />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 14 }}>
              <Space size="middle">
                <Button onClick={handleClose} danger>
                  ยกเลิก
                </Button>
                <Button type="primary" htmlType="submit">
                  บันทึก
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </Modal>
  );
};

export default UpdateFinalCaseDoc;
